import { render, staticRenderFns } from "./PricingAttributeConfiguration.vue?vue&type=template&id=38eb83b7&scoped=true&"
import script from "./PricingAttributeConfiguration.vue?vue&type=script&lang=js&"
export * from "./PricingAttributeConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./PricingAttributeConfiguration.vue?vue&type=style&index=0&id=38eb83b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38eb83b7",
  null
  
)

export default component.exports